import { render, staticRenderFns } from "./ncbRetentionModal.vue?vue&type=template&id=9b48a96e&scoped=true"
import script from "./ncbRetentionModal.vue?vue&type=script&lang=js"
export * from "./ncbRetentionModal.vue?vue&type=script&lang=js"
import style0 from "./ncbRetentionModal.vue?vue&type=style&index=0&id=9b48a96e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b48a96e",
  null
  
)

export default component.exports